<app-card [collapsible]="true" [startCollapsed]="startCollapsed()">
  <div card-header>
    <h2>1. {{ selectedRegisteredAppliance()?.applianceName }}</h2>
    <app-icon
      [family]="'solid'"
      [name]="'circle-check'"
      [size]="'md'"
      class="registered-appliance-icon"
    />
    <app-badge-text
      [color]="'blue'"
      [icon]="`fa-light fa-file-check`"
      [text]="'Registered Appliance'"
    />
  </div>
  <div card-collapsible>
    <h3>{{ selectedRegisteredAppliance()?.manufacturer }}</h3>
    <h3>
      {{ selectedRegisteredAppliance()?.purchaseMonth }}
      {{ selectedRegisteredAppliance()?.purchaseYear }}
    </h3>
    <h3>
      {{ selectedRegisteredAppliance()?.purchasePrice | priceBand }}
    </h3>
    <p class="registered-appliances__price-disclaimer">
      {{ "PRICE_TAX_DISCLAIMER" | translate }}
    </p>
  </div>
</app-card>
